import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blockCard", "timeline"]
  static values = { baseUrl: String, selectedIndex: Number }

  connect() {
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    this.scrollToSelected()
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  selectBlock(event) {
    const card = event.currentTarget
    const index = parseInt(card.dataset.index, 10)
    if (isNaN(index)) return

    window.location.href = `${this.baseUrlValue}?block_index=${index}`
  }

  keydown(event) {
    // Don't intercept when typing in form fields
    if (event.target.matches("input, textarea, select")) return

    switch (event.key) {
      case "ArrowUp":
      case "k":
        event.preventDefault()
        this.previousBlock()
        break
      case "ArrowDown":
      case "j":
        event.preventDefault()
        this.nextBlock()
        break
      case "Home":
        event.preventDefault()
        this.firstBlock()
        break
      case "End":
        event.preventDefault()
        this.lastBlock()
        break
    }
  }

  previousBlock() {
    this.navigateTo(this.selectedIndexValue - 1)
  }

  nextBlock() {
    this.navigateTo(this.selectedIndexValue + 1)
  }

  firstBlock() {
    this.navigateTo(0)
  }

  lastBlock() {
    this.navigateTo(this.blockCardTargets.length - 1)
  }

  navigateTo(index) {
    const max = this.blockCardTargets.length - 1
    if (max < 0) return

    const clamped = Math.max(0, Math.min(index, max))
    if (clamped !== this.selectedIndexValue) {
      window.location.href = `${this.baseUrlValue}?block_index=${clamped}`
    }
  }

  scrollToSelected() {
    const selected = this.blockCardTargets[this.selectedIndexValue]
    if (selected) {
      selected.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
}
